import { render } from "./ZoomControl.vue?vue&type=template&id=6079dabd&scoped=true"
import script from "./ZoomControl.vue?vue&type=script&lang=js"
export * from "./ZoomControl.vue?vue&type=script&lang=js"

import "./ZoomControl.vue?vue&type=style&index=0&id=6079dabd&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6079dabd"]])

export default __exports__
import QCard from 'quasar/src/components/card/QCard.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import qInstall from "../../../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QCard,QCardSection,QBtn,QIcon,QTooltip});
